module.exports = __webpack_public_path__ + "img/mental-health-01.95581905.jpg";